import { ImageWithArtDirection } from 'src/components/ui/Image'
import imagesConf from 'src/images/config'

import type { CarouselInformativeItemsBackgroundProps } from '../carousel-informative'
import { getClassNameByContentConfiguration } from '../utils'

interface BackgroundProps {
  background: CarouselInformativeItemsBackgroundProps
  classSlide: string
  index: number
  children: JSX.Element
  contentConfiguration: {
    alignContentHorizontally: string
  }
}

const Background = ({
  background,
  classSlide = '',
  children,
  index,
  contentConfiguration,
}: BackgroundProps) => {
  const desktopBaseUrl =
    background.backgroundImages.find(
      (item) => item.device === '(min-width: 48em)'
    )?.src ?? ''

  const mobileBaseUrl =
    background.backgroundImages.find(
      (item) => item.device === '(max-width: 48em)'
    )?.src ?? ''

  const desktop = {
    baseUrl: desktopBaseUrl,
    ...imagesConf['heroCarousel.desktop'],
  }

  const mobile = {
    baseUrl: mobileBaseUrl,
    ...imagesConf['heroCarousel.mobile'],
  }

  const configuredClassName = getClassNameByContentConfiguration(
    classSlide,
    contentConfiguration
  )

  if (!background || !background.backgroundImages.length) {
    return <>{children}</>
  }

  return (
    <>
      <div
        className={`${classSlide} ${configuredClassName}`}
        style={{ backgroundColor: `${background.backgroundColor ?? ''}` }}
      >
        <ImageWithArtDirection
          desktop={desktop}
          mobile={mobile}
          media={{ desktop: '(min-width: 48em)' }}
          alt={background.alt}
          objectFit="cover"
          loading={index === 0 ? 'eager' : 'lazy'}
        />
        {children}
      </div>
    </>
  )
}

export default Background
